<template>
  <section class="News-root m-index-newsBox g-box">
    <ul class="news-ul">
      <h2 class="u-news-h2">新闻资讯</h2>
      <li class="news-li" v-for="(item,index) in newsList" :key="index" v-if="index < 4" @mouseover="hoverNews('new',index)">
        <div v-if="index == anchor.new" class="li-active">
          <div class="imgBox">
            <img class="img" :src="item.img" alt="">
          </div>
          <div class="rt">
            <div class="hd">
              <h4 class="h4" @click="jumpArticle(item.id)">{{ item.title }}</h4>
              <p class="detail">{{ item.detail }}</p>
            </div>
            <div class="time">{{ item.time }}</div>
          </div>
        </div>
        <div v-else class="li">
          <p class="lt">{{item.title}}</p>
          <p class="rt">{{ item.time }}</p>
        </div>
      </li>
    </ul>
    <ul class="news-ul">
      <h2 class="u-news-h2">技术团队</h2>
      <li class="news-li" v-for="(item,index) in news2List" :key="index" v-if="index < 4" @mouseover="hoverNews('new2',index)">
        <div v-if="index == anchor.new2" class="li-active">
          <div class="imgBox">
            <img class="img" :src="item.img" alt="">
          </div>
          <div class="rt">
            <div class="hd">
              <h4 class="h4" @click="jumpArticle(item.id)">{{ item.title }}</h4>
              <p class="detail">{{ item.detail }}</p>
            </div>
            <div class="time">{{ item.create_time }}</div>
          </div>
        </div>
        <div v-else class="li">
          <p class="lt">{{item.title}}</p>
          <p class="rt">{{ item.create_time }}</p>
        </div>
      </li>
    </ul>
  </section>
</template>
<script>
  export default {
    name       : 'News',
    components : {},
    props      : {
      newsList  : {
        type    : Array,
        default : [],
      },
      news2List : {
        type    : Array,
        default : [],
      }
    },
    data(){
      return {
        anchor : {
          new  : 0,
          new2 : 0,
        },
      };
    },
    computed   : {},
    created(){},
    methods    : {
      hoverNews(obj, index){
        this.anchor[obj] = index;
      },
      jumpArticle(id){
        location.href= this.$api.domainName + "article_info.html" + '?id=' + id;
      }
    },
  };
</script>
<style scoped lang="scss">
  @media screen and(min-width: 768px){
    .m-index-newsBox{
      .news-ul{
        flex: 1;
        &:first-child{
          margin-right: 20px;
        }
      }
    }
  }
  .m-index-newsBox{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .li-active{
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      padding-bottom: 16px;
      border-bottom: 1Px solid #e3e3e3;
      $h: 100px;
      .imgBox{
        width: 40%;
        min-height: $h;
        display: flex;
        align-items: center;
        justify-content: center;
        .img{
          max-width: 100%;
          max-height: 100%;
        }
      }
      .rt{
        margin-left: 10Px;
        flex: 1;
        min-height: $h;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .h4{
        font-size: 15Px;
        @extend %btn_base;
      }
      .detail{
        color: #999;
        @include ellipsis(90%, 3);
        min-height: 4.5em;
      }
      .time{
        text-align: right;
      }
    }
    .li{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 0;
      cursor: pointer;
      -webkit-user-select: none;
      user-select: none;
      .lt{
        @include ellipsis(60%);
      }
      .rt{
        color: #999;
        font-size: 12Px;
      }
    }
  }
</style>
